// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1EE92","header":"MessagesList_header__3FBhm","chat":"MessagesList_chat__3hITF"};